var _rect, _circle, _rect2, _rect3, _rect4, _rect5, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNutrition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 420,
    height: 260,
    viewBox: "0 0 420 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 260,
    rx: 22,
    fill: "#fff6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 130,
    r: 58,
    fill: "#f59e0b",
    opacity: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 70,
    width: 170,
    height: 140,
    rx: 18,
    fill: "#ffffff",
    stroke: "#f0d9b5",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 95,
    width: 120,
    height: 14,
    rx: 7,
    fill: "#0f766e",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 122,
    width: 90,
    height: 10,
    rx: 5,
    fill: "#f59e0b",
    opacity: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 145,
    width: 110,
    height: 10,
    rx: 5,
    fill: "#0f766e",
    opacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 190,
    r: 30,
    fill: "#0f766e",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutrition);
export default __webpack_public_path__ + "static/media/nutrition.3f393edabab07cb1ce79b8accd0094a7.svg";
export { ForwardRef as ReactComponent };